module.exports = __webpack_public_path__ + "static/media/zero_sugar.d7b439cc.svg";